function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F2F2F2",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "10%",
  stopColor: "#EBECEE",
  stopOpacity: 0.11
}), /*#__PURE__*/React.createElement("stop", {
  offset: "54%",
  stopColor: "#CAD3DB",
  stopOpacity: 0.58
}), /*#__PURE__*/React.createElement("stop", {
  offset: "85%",
  stopColor: "#B5C2D0",
  stopOpacity: 0.88
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#ADBCCB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#2C567F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#184470"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: "49.972%",
  x2: "49.972%",
  y1: "-.006%",
  y2: "100.019%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#2C567F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#184470"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: "50%",
  x2: "50%",
  y1: "-.008%",
  y2: "99.992%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#2C567F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#184470"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(-1)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 179.5,
  cy: 161.5,
  r: 161.5,
  fill: "url(#c)",
  fillRule: "nonzero",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 67)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(100.753 14.658)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#15406B",
  fillRule: "nonzero",
  d: "M36.445 0H244.47a4.787 4.787 0 0 1 4.792 4.782V139.51H31.653V4.782A4.787 4.787 0 0 1 36.445 0zM0 140.826v4.447c0 .501.284.959.733 1.182l11.959 5.94c.366.182.77.275 1.178.274h251.857c.408.001.812-.092 1.178-.274l11.959-5.94c.449-.223.733-.681.733-1.182v-4.447c0-.727-.59-1.316-1.319-1.316H1.318A1.32 1.32 0 0 0 0 140.826z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E4EAEF",
  fillRule: "nonzero",
  d: "M36.928 11.843h207.06v121.082H36.928z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#d)",
  fillRule: "nonzero",
  d: "M244.128 75.043L36.86 84.14V10.564h207.268z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M117.376 139.51h46.157v3.35a1.915 1.915 0 0 1-1.916 1.914h-42.318a1.915 1.915 0 0 1-1.917-1.913v-3.35h-.006z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140.146,
  cy: 30.527,
  r: 3.257,
  fill: "#FFF",
  stroke: "#FFF",
  strokeWidth: 1.086
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D78890",
  fillRule: "nonzero",
  d: "M141.11 71.015l11.135 11.111a1.862 1.862 0 0 1 0 2.636L141.11 95.873a1.862 1.862 0 0 1-2.631 0l-11.134-11.11a1.862 1.862 0 0 1 0-2.637l11.134-11.111a1.862 1.862 0 0 1 2.63 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DCBC7B",
  fillRule: "nonzero",
  d: "M141.117 67.542l11.134 11.111a1.862 1.862 0 0 1 0 2.636L141.117 92.4a1.862 1.862 0 0 1-2.63 0l-11.135-11.11a1.862 1.862 0 0 1 0-2.637l11.134-11.11a1.862 1.862 0 0 1 2.631 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A2B688",
  fillRule: "nonzero",
  d: "M141.113 64.074l11.134 11.11a1.862 1.862 0 0 1 0 2.637l-11.134 11.111a1.862 1.862 0 0 1-2.63 0l-11.135-11.111a1.862 1.862 0 0 1 0-2.636l11.134-11.111a1.862 1.862 0 0 1 2.631 0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 58.642,
  height: 3.497,
  x: 110.166,
  y: 103.256,
  fill: "#15406B",
  fillRule: "nonzero",
  rx: 1.368
}), /*#__PURE__*/React.createElement("rect", {
  width: 49.314,
  height: 3.497,
  x: 114.83,
  y: 109.835,
  fill: "#15406B",
  fillRule: "nonzero",
  rx: 1.368
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M100.88 122.312h77.836a1.42 1.42 0 0 1 1.422 1.42v8.992h-80.68v-8.992c0-.784.637-1.42 1.423-1.42zM65.01 50.522l.475-.097c.416-.098.538-.17.538-1.018v-6.616c0-.847-.122-.92-.538-1.017l-.476-.098v-.383h4.548v.383l-.458.098c-.445.128-.543.17-.543 1.017v6.616c0 .847.086.89.543 1.018l.458.097v.384H65.01v-.384zm3.882-4.179v-.25l2.442-2.833c.262-.26.428-.602.47-.968 0-.25-.165-.42-.458-.5l-.403-.116v-.383h3.352v.383l-.318.086c-.519.14-.726.316-1.49 1.182l-1.782 1.986a38.67 38.67 0 0 0 3.162 5.16.72.72 0 0 0 .44.335l.421.097v.384h-3.156a27.633 27.633 0 0 1-2.68-4.563z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M74.478 47.312a3.554 3.554 0 0 1 1.02-2.752 3.57 3.57 0 0 1 2.746-1.05c2.015 0 3.785 1.219 3.785 3.735a3.578 3.578 0 0 1-1.024 2.77 3.594 3.594 0 0 1-2.76 1.062c-2.021 0-3.767-1.225-3.767-3.765zm5.213.073c0-2.803-.543-3.333-1.49-3.333-.946 0-1.391.61-1.391 3.046 0 2.845.458 3.455 1.477 3.455.824.012 1.398-.506 1.398-3.168h.006zM82.414 50.565l.36-.098c.464-.128.519-.195.519-.792v-4.343c0-.61-.073-.61-.464-.902l-.458-.31v-.257l2.936-.335.153.11.006.835h.055a4.413 4.413 0 0 1 2.558-.987 1.581 1.581 0 0 1 1.66 1.023h.068a4.554 4.554 0 0 1 2.63-.999c1.081 0 1.722.61 1.722 1.828v4.264c0 .61.055.683.5.792l.361.098v.371h-3.834v-.298l.318-.085c.39-.11.433-.153.433-.805V45.91c0-.816-.226-1.108-.867-1.108a4.71 4.71 0 0 0-1.22.195c.008.156.008.312 0 .469v4.179c0 .652.054.694.415.804l.323.085v.372h-3.712v-.341l.318-.085c.372-.11.433-.153.433-.805V45.91c0-.816-.226-1.108-.867-1.108a5.23 5.23 0 0 0-1.22.182v4.66c0 .665.054.695.433.805l.317.085v.372h-3.876v-.341zM95.295 50.565l.36-.098c.458-.128.513-.195.513-.792v-4.343c0-.61-.067-.61-.458-.902l-.458-.31v-.257l2.93-.335.153.11-.049.835h.055a4.443 4.443 0 0 1 2.558-.987 1.57 1.57 0 0 1 1.66 1.023h.068c.75-.601 1.67-.95 2.63-.999 1.087 0 1.728.61 1.728 1.828v4.264c0 .61.055.683.501.792l.36.098v.371h-3.84v-.298l.318-.085c.39-.11.433-.153.433-.805V45.91c0-.816-.22-1.108-.86-1.108a4.716 4.716 0 0 0-1.222.195c.02.155.03.312.031.469v4.179c0 .652.055.694.415.804l.318.085v.372h-3.712v-.341l.323-.085c.373-.11.428-.153.428-.805V45.91c0-.816-.22-1.108-.861-1.108a5.285 5.285 0 0 0-1.221.182v4.66c0 .665.061.695.433.805l.318.085v.372h-3.852v-.341zM108.786 49.23V45.26c0-.61 0-.64-.433-.872l-.482-.28v-.292l2.973-.305.164.128v5.05c0 .817.324 1.14.947 1.14a4.159 4.159 0 0 0 1.306-.28v-4.265c0-.61-.037-.652-.44-.871l-.494-.305v-.292l2.96-.305.172.128v5.605c0 .682.036.761.458.932l.403.164v.336l-2.882.402-.153-.116.031-.926h-.073c-.746.63-1.68.997-2.656 1.042a1.675 1.675 0 0 1-1.337-.5 1.667 1.667 0 0 1-.464-1.346zM116.6 50.565l.36-.098c.458-.128.513-.195.513-.792v-4.343c0-.61-.067-.61-.458-.902l-.457-.31v-.257l2.936-.335.153.098.006.847h.055a4.664 4.664 0 0 1 2.674-.987c1.178 0 1.83.609 1.83 1.827v4.265c0 .61.056.682.502.792l.36.097v.372h-3.877v-.274l.33-.085c.421-.11.464-.153.464-.805V45.91c0-.846-.312-1.108-.965-1.108a5.884 5.884 0 0 0-1.294.182v4.66c0 .665.043.695.464.805l.33.085v.372H116.6v-.341zM125.452 47.275a3.584 3.584 0 0 1 1-2.663 3.6 3.6 0 0 1 2.626-1.102c1.923 0 3.12.957 3.157 3.473h-4.585c.043 2.272.903 2.9 2.332 2.9a4.2 4.2 0 0 0 2.045-.53v.456a4.064 4.064 0 0 1-2.949 1.268c-2.417 0-3.626-1.444-3.626-3.802zm2.198-.822l2.375-.122c0-1.682-.22-2.29-1.056-2.29-.709 0-1.264.663-1.32 2.412zM133.321 50.285v-8.079c0-.682-.036-.749-.427-.944l-.52-.25v-.316l3.053-.28.153.109s-.043.652-.043 1.627v.944c-.012.767-.012 1.377-.012 1.377h.067a3.514 3.514 0 0 1 2.314-.932c1.306 0 2.71.877 2.71 3.417 0 2.882-1.74 4.15-4.114 4.15a5.607 5.607 0 0 1-3.18-.823zm4.994-2.888c0-1.986-.61-2.68-1.655-2.68-.383.005-.762.09-1.11.25v5.056c.273.321.676.505 1.098.5 1.1 0 1.667-.567 1.667-3.126zM141.154 49.243c0-1.219.934-1.76 2.502-2.138l1.405-.348V45.54c0-1.152-.22-1.499-.983-1.499-.422 0-.562.11-.61.5-.068.877-.36 1.218-1.087 1.218a.825.825 0 0 1-.947-.865c0-.89 1.142-1.401 3.053-1.401 1.74 0 2.753.542 2.753 1.9v3.845c0 .518.055.725.317.865.207.086.43.132.654.134v.329a2.66 2.66 0 0 1-1.624.487c-.806 0-1.294-.304-1.447-.847h-.073c-.457.561-1.151.875-1.874.847-1.258.025-2.04-.646-2.04-1.81zm3.907.445v-2.224l-.61.06c-.715.056-1.088.372-1.088 1.372 0 .901.403 1.218.947 1.218a.812.812 0 0 0 .75-.426zM148.473 50.565l.36-.098c.458-.128.513-.195.513-.792v-4.343c0-.61-.067-.61-.458-.902l-.458-.31v-.257l2.937-.335.152.11v.963h.055a3.121 3.121 0 0 1 2.033-1.073.96.96 0 0 1 1.069 1.042.943.943 0 0 1-.959 1.042 1.008 1.008 0 0 1-1.068-.61.287.287 0 0 0-.293-.176c-.29.031-.56.158-.77.36v4.495c0 .652.062.725.477.792l.458.098v.372h-4.017l-.03-.378zM154.743 47.312a3.56 3.56 0 0 1 1.025-2.752 3.575 3.575 0 0 1 2.747-1.05c2.015 0 3.78 1.219 3.78 3.735a3.572 3.572 0 0 1-1.02 2.77 3.588 3.588 0 0 1-2.76 1.062c-2.02 0-3.772-1.225-3.772-3.765zm5.22.073c0-2.803-.544-3.333-1.49-3.333-.947 0-1.392.61-1.392 3.046 0 2.845.458 3.455 1.477 3.455.83.012 1.386-.506 1.386-3.168h.018zM162.715 50.565l.36-.098c.458-.128.513-.195.513-.792v-4.343c0-.61-.067-.61-.457-.902l-.458-.31v-.257l2.936-.335.153.11v.877h.055a4.443 4.443 0 0 1 2.564-.987 1.57 1.57 0 0 1 1.636 1h.073a4.553 4.553 0 0 1 2.625-1c1.087 0 1.728.61 1.728 1.828v4.265c0 .609.055.682.5.792l.36.097v.372h-3.84v-.317l.324-.085c.39-.11.427-.153.427-.805V45.91c0-.816-.22-1.108-.86-1.108a4.801 4.801 0 0 0-1.221.195 3.1 3.1 0 0 1 .03.469v4.179c0 .652.055.694.415.804l.324.085v.372h-3.718v-.341l.324-.085c.372-.11.427-.153.427-.805V45.91c0-.816-.22-1.108-.86-1.108a5.23 5.23 0 0 0-1.222.182v4.66c0 .665.055.695.428.805l.323.085v.372h-3.84l-.049-.341zM175.682 47.275a3.584 3.584 0 0 1 .999-2.663 3.6 3.6 0 0 1 2.627-1.102c1.923 0 3.12.957 3.156 3.473h-4.584c.036 2.272.903 2.9 2.332 2.9a4.2 4.2 0 0 0 2.045-.53v.456a4.076 4.076 0 0 1-2.949 1.268c-2.417 0-3.626-1.444-3.626-3.802zm2.198-.822l2.374-.122c0-1.682-.22-2.29-1.056-2.29-.708 0-1.263.663-1.318 2.412zM183.606 49.158V44.52h-.873v-.329a3.848 3.848 0 0 0 2.307-2.333h.794v1.828h1.831l-.183.816h-1.666v4.502c0 .695.207.969.903.969a5.23 5.23 0 0 0 1.001-.122v.384a3.16 3.16 0 0 1-2.197.822c-1.233.019-1.917-.536-1.917-1.9zM188.074 47.275a3.584 3.584 0 0 1 .995-2.659 3.6 3.6 0 0 1 2.62-1.106c1.922 0 3.119.957 3.162 3.473h-4.591c.043 2.272.903 2.9 2.332 2.9a4.2 4.2 0 0 0 2.045-.53v.456a4.051 4.051 0 0 1-2.949 1.268c-2.405 0-3.614-1.444-3.614-3.802zm2.198-.822l2.375-.122c0-1.682-.22-2.29-1.056-2.29-.708 0-1.264.663-1.319 2.412zM195.278 50.565l.36-.098c.464-.128.52-.195.52-.792v-4.343c0-.61-.074-.61-.465-.902l-.458-.31v-.257l2.937-.335.152.11v.963h.055a3.097 3.097 0 0 1 2.027-1.073.96.96 0 0 1 1.05 1.024.943.943 0 0 1-.964 1.042c-.454.06-.891-.19-1.069-.61a.28.28 0 0 0-.293-.176 1.29 1.29 0 0 0-.763.36v4.495c0 .652.055.725.47.792l.458.098v.371h-4.017v-.36zM201.828 47.275a3.584 3.584 0 0 1 1.001-2.666 3.6 3.6 0 0 1 2.632-1.099c1.917 0 3.113.957 3.156 3.473h-4.59c.042 2.272.903 2.9 2.337 2.9a4.237 4.237 0 0 0 2.045-.53v.456a4.076 4.076 0 0 1-2.948 1.268c-2.418 0-3.633-1.444-3.633-3.802zm2.198-.822l2.381-.122c0-1.682-.226-2.29-1.056-2.29-.708 0-1.27.663-1.325 2.412zM209.758 49.158V44.52h-.872v-.329a3.866 3.866 0 0 0 2.338-2.333h.793v1.828h1.832l-.183.816h-1.667v4.502c0 .695.207.969.903.969.337-.009.673-.05 1.002-.122v.384a3.16 3.16 0 0 1-2.198.822c-1.264.019-1.948-.536-1.948-1.9z"
}), /*#__PURE__*/React.createElement("text", {
  fill: "#3A5E01",
  fontFamily: "PublicoHeadline-Medium, Publico Headline",
  fontSize: 10.858,
  fontWeight: 400
}, /*#__PURE__*/React.createElement("tspan", {
  x: 137.521,
  y: 79.596
}, "1"))), /*#__PURE__*/React.createElement("rect", {
  width: 123.19,
  height: 166.212,
  x: 2.868,
  y: 1.836,
  fill: "#E0BAC3",
  fillRule: "nonzero",
  rx: 3.671
}), /*#__PURE__*/React.createElement("path", {
  fill: "#15406B",
  fillRule: "nonzero",
  d: "M122.387 3.671c1.014 0 1.835.822 1.835 1.836v158.869a1.836 1.836 0 0 1-1.835 1.836H6.52a1.836 1.836 0 0 1-1.836-1.836V5.506c0-1.013.822-1.835 1.836-1.835h115.866m0-3.671H6.52a5.507 5.507 0 0 0-5.507 5.507v158.869a5.507 5.507 0 0 0 5.507 5.507h115.866a5.507 5.507 0 0 0 5.507-5.507V5.506A5.507 5.507 0 0 0 122.387 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#15406B",
  fillRule: "nonzero",
  d: "M3.235 158.3h122.45v9.374H3.235z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#e)",
  fillRule: "nonzero",
  d: "M124.614 107.176L4.374 89.564V9.79c0-1.444 2.275-2.613 5.084-2.613h110.04c2.81 0 5.085 1.17 5.085 2.613l.031 97.386z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#15406B",
  fillRule: "nonzero",
  d: "M126.792 10.482H1.014v4.411C1.014 2.76-.026.551 13.71.551h101.457c11.625 0 11.625 2.209 11.625 14.342v-4.411z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 67.656,
  height: 2.778,
  x: 30.452,
  y: 119.678,
  fill: "#15406B",
  fillRule: "nonzero",
  opacity: 0.29,
  rx: 1.389
}), /*#__PURE__*/React.createElement("rect", {
  width: 47.5,
  height: 2.778,
  x: 39.954,
  y: 55.762,
  fill: "#FFF",
  fillRule: "nonzero",
  opacity: 0.5,
  rx: 1.267
}), /*#__PURE__*/React.createElement("rect", {
  width: 30.955,
  height: 2.778,
  x: 48.227,
  y: 61.281,
  fill: "#FFF",
  fillRule: "nonzero",
  opacity: 0.5,
  rx: 1.267
}), /*#__PURE__*/React.createElement("rect", {
  width: 51.814,
  height: 2.778,
  x: 38.369,
  y: 130.013,
  fill: "#15406B",
  fillRule: "nonzero",
  opacity: 0.29,
  rx: 1.267
}), /*#__PURE__*/React.createElement("rect", {
  width: 66.616,
  height: 2.778,
  x: 30.972,
  y: 124.903,
  fill: "#15406B",
  fillRule: "nonzero",
  opacity: 0.29,
  rx: 1.389
}), /*#__PURE__*/React.createElement("rect", {
  width: 24.383,
  height: 1.652,
  x: 46.146,
  y: 158.282,
  fill: "#15406B",
  fillRule: "nonzero",
  opacity: 0.29,
  rx: 0.753
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42.677,
  cy: 159.108,
  r: 1,
  fill: "#15406B",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("rect", {
  width: 19.55,
  height: 19.55,
  x: 54.229,
  y: 86.405,
  fill: "#D78890",
  fillRule: "nonzero",
  rx: 2.099,
  transform: "rotate(45 64.004 96.18)"
}), /*#__PURE__*/React.createElement("text", {
  fill: "#B21A2D",
  fontFamily: "PublicoHeadline-Medium, Publico Headline",
  fontSize: 11.032,
  fontWeight: 400
}, /*#__PURE__*/React.createElement("tspan", {
  x: 58.06,
  y: 100.293
}, "97")), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  stroke: "#FFF",
  strokeLinejoin: "round",
  strokeWidth: 0.612,
  d: "M66.742 30.82c0 3.604-3.06 5.85-3.06 5.85s-3.059-2.246-3.059-5.85l3.06-1.223 3.06 1.223z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(88.122 32.574)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#15406B",
  fillRule: "nonzero",
  d: "M44.071 0h26.691c5.692 0 11.64 5.569 11.64 10.91v124.475h-38.33V0z",
  opacity: 0.15
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BAC6A7",
  fillRule: "nonzero",
  d: "M2.414 67.386h69.224v76.484a7.437 7.437 0 0 1-7.437 7.443H9.851a7.437 7.437 0 0 1-7.437-7.443V67.386z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#f)",
  fillRule: "nonzero",
  d: "M71.638 78.413L3.027 90.665V12.087A2.904 2.904 0 0 1 5.93 9.189h62.804c1.601 0 2.9 1.296 2.903 2.898v66.326z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#15406B",
  fillRule: "nonzero",
  d: "M63.828 9.19a7.351 7.351 0 0 1 7.351 7.35v126.197a7.351 7.351 0 0 1-7.351 7.35H10.53a7.351 7.351 0 0 1-7.351-7.35V16.54a7.351 7.351 0 0 1 7.351-7.35h53.297m0-2.451H10.53C5.118 6.739.73 11.127.73 16.54v126.197c0 5.413 4.388 9.801 9.801 9.801h53.297a9.802 9.802 0 0 0 9.801-9.801V16.54c0-5.413-4.388-9.801-9.801-9.801z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#15406B",
  fillRule: "nonzero",
  d: "M51.882 14.09H22.477c-3.382 0-4.9-3.014-4.9-6.739h39.206c0 3.719-1.52 6.739-4.901 6.739z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 51.655,
  height: 3.088,
  x: 11.407,
  y: 109.962,
  fill: "#15406B",
  fillRule: "nonzero",
  opacity: 0.29,
  rx: 1.544
}), /*#__PURE__*/React.createElement("rect", {
  width: 32.051,
  height: 3.088,
  x: 20.596,
  y: 54.215,
  fill: "#FFF",
  fillRule: "nonzero",
  opacity: 0.5,
  rx: 1.544
}), /*#__PURE__*/React.createElement("rect", {
  width: 22.25,
  height: 3.088,
  x: 25.497,
  y: 60.341,
  fill: "#FFF",
  fillRule: "nonzero",
  opacity: 0.5,
  rx: 1.544
}), /*#__PURE__*/React.createElement("rect", {
  width: 39.556,
  height: 3.088,
  x: 17.46,
  y: 121.442,
  fill: "#15406B",
  fillRule: "nonzero",
  opacity: 0.29,
  rx: 1.544
}), /*#__PURE__*/React.createElement("rect", {
  width: 50.858,
  height: 3.088,
  x: 11.805,
  y: 115.77,
  fill: "#15406B",
  fillRule: "nonzero",
  opacity: 0.29,
  rx: 1.544
}), /*#__PURE__*/React.createElement("rect", {
  width: 17.153,
  height: 17.153,
  x: 28.258,
  y: 75.497,
  fill: "#A2B688",
  fillRule: "nonzero",
  rx: 2.101,
  transform: "rotate(45 36.835 84.073)"
}), /*#__PURE__*/React.createElement("text", {
  fill: "#3A5E01",
  fontFamily: "PublicoHeadline-Medium, Publico Headline",
  fontSize: 12.252,
  fontWeight: 400
}, /*#__PURE__*/React.createElement("tspan", {
  x: 34.551,
  y: 88.358
}, "1")), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  stroke: "#FFF",
  strokeLinejoin: "round",
  strokeWidth: 0.613,
  d: "M40.23 29.975c0 3.602-3.063 5.856-3.063 5.856s-3.063-2.254-3.063-5.856l3.063-1.226 3.063 1.226z"
})), /*#__PURE__*/React.createElement("rect", {
  width: 39.089,
  height: 4.343,
  x: 105.639,
  y: 75.464,
  fill: "#FFF",
  rx: 2.172
}), /*#__PURE__*/React.createElement("rect", {
  width: 39.089,
  height: 4.343,
  x: 44.834,
  y: 44.518,
  fill: "#FFF",
  rx: 2.172
})));

var SvgKb = function SvgKb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 323,
    viewBox: "0 0 380 323",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kb.7835d98a.svg";
export { ForwardRef as ReactComponent };